// VOZE product page: update color swatch active states
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.voze-color-swatch').forEach(function(label) {
    var input = document.getElementById(label.getAttribute('for'));
    if (!input) return;
    input.addEventListener('change', function() {
      // Remove active from siblings
      var fieldset = label.closest('fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('.voze-color-swatch').forEach(function(s) {
          s.classList.remove('is-active');
        });
      }
      if (input.checked) {
        label.classList.add('is-active');
      }
    });
  });
});
